module.exports = __webpack_public_path__ + "media/10.43dd7341.wav";